module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Angle-double-up-e336741b1a855012d3e326bf7e26ee3d.svg";